/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*************************************************!*\
  !*** ./src/js/product-comparison-table-2026.js ***!
  \*************************************************/
(function () {
  var sectionRoot = document.querySelector('.product-comparison-table-2026__scroll-wrap');

  if (!sectionRoot) {
    return;
  }

  var scroller = sectionRoot.querySelector('[data-comparison-scroll]');
  var scrollWrap = sectionRoot;
  var prevButton = sectionRoot.querySelector('[data-comparison-prev]');
  var nextButton = sectionRoot.querySelector('[data-comparison-next]');
  var labelsColumn = sectionRoot.querySelector('.product-comparison-table-2026__labels');
  var productItems = scroller ? scroller.querySelectorAll('.product-comparison-table-2026__product') : [];

  if (!scroller || !prevButton || !nextButton) {
    return;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function getVisibleProductRange() {
    if (!productItems.length) {
      return null;
    }

    var visibleStart = getVisibleContentStart();
    var scrollerRect = scroller.getBoundingClientRect();
    var visibleStartX = scrollerRect.left + visibleStart;
    var visibleEndX = scrollerRect.right;
    var firstVisibleItem = null;
    var lastVisibleItem = null;
    var firstButtonSafeItem = null;
    var lastButtonSafeItem = null;
    var minPrevVisibleWidth = prevButton.offsetWidth + 24;
    var minNextVisibleWidth = nextButton.offsetWidth + 24;

    for (var index = 0; index < productItems.length; index += 1) {
      var itemRect = productItems[index].getBoundingClientRect();
      var overlapStart = Math.max(itemRect.left, visibleStartX);
      var overlapEnd = Math.min(itemRect.right, visibleEndX);
      var visibleWidth = Math.max(0, overlapEnd - overlapStart);
      var isVisible = visibleWidth > 2;
      var minButtonSafeWidth = Math.max(Math.round(itemRect.width * 0.45), Math.max(minPrevVisibleWidth, minNextVisibleWidth));

      if (!isVisible) {
        continue;
      }

      if (!firstVisibleItem) {
        firstVisibleItem = productItems[index];
      }

      if (!firstButtonSafeItem && visibleWidth >= minButtonSafeWidth) {
        firstButtonSafeItem = productItems[index];
      }

      if (visibleWidth >= minButtonSafeWidth) {
        lastButtonSafeItem = productItems[index];
      }

      lastVisibleItem = productItems[index];
    }

    return {
      firstVisibleItem: firstButtonSafeItem || firstVisibleItem || productItems[0],
      lastVisibleItem: lastButtonSafeItem || lastVisibleItem || productItems[productItems.length - 1]
    };
  }

  function updateButtonPositions() {
    if (isMobileViewport()) {
      prevButton.style.left = '';
      prevButton.style.right = '';
      nextButton.style.left = '';
      nextButton.style.right = '';
      return;
    }

    var visibleRange = getVisibleProductRange();

    if (!visibleRange || !scrollWrap) {
      return;
    }

    var wrapRect = scrollWrap.getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();
    var prevCardRect = visibleRange.firstVisibleItem.getBoundingClientRect();
    var nextCardRect = visibleRange.lastVisibleItem.getBoundingClientRect();
    var prevInset = 12;
    var nextInset = 12;
    var visibleStart = scrollerRect.left + getVisibleContentStart() - wrapRect.left;
    var visibleEnd = scrollerRect.right - wrapRect.left;
    var prevVisibleStart = Math.max(prevCardRect.left - wrapRect.left, visibleStart);
    var prevVisibleEnd = Math.min(prevCardRect.right - wrapRect.left, visibleEnd);
    var nextVisibleStart = Math.max(nextCardRect.left - wrapRect.left, visibleStart);
    var nextVisibleEnd = Math.min(nextCardRect.right - wrapRect.left, visibleEnd);
    var prevMinLeft = prevVisibleStart + prevInset;
    var prevMaxLeft = prevVisibleEnd - prevButton.offsetWidth - prevInset;
    var nextMinLeft = nextVisibleStart + nextInset;
    var nextMaxLeft = nextVisibleEnd - nextButton.offsetWidth - nextInset;
    var prevLeft = prevMaxLeft >= prevMinLeft ? prevMinLeft : prevVisibleStart + Math.max(0, (prevVisibleEnd - prevVisibleStart - prevButton.offsetWidth) / 2);
    var nextLeft = nextMaxLeft >= nextMinLeft ? nextMaxLeft : nextVisibleStart + Math.max(0, (nextVisibleEnd - nextVisibleStart - nextButton.offsetWidth) / 2);
    prevButton.style.left = Math.round(prevLeft) + 'px';
    prevButton.style.right = 'auto';
    nextButton.style.left = Math.round(nextLeft) + 'px';
    nextButton.style.right = 'auto';
  }

  function updateScrollButtons() {
    var edgeThreshold = 6;
    var scrollLeft = scroller.scrollLeft;
    var scrollWidth = scroller.scrollWidth;
    var clientWidth = scroller.clientWidth;
    var maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
    var hasOverflow = maxScrollLeft > edgeThreshold;
    var canScrollLeft = scrollLeft > edgeThreshold;
    var canScrollRight = maxScrollLeft - scrollLeft > edgeThreshold; // Use the last product's visible position for end detection, which is
    // more reliable than scrollLeft math in snapped/fractional layouts.

    if (productItems.length) {
      var lastProduct = productItems[productItems.length - 1];
      var scrollerRect = scroller.getBoundingClientRect();
      var lastProductRect = lastProduct.getBoundingClientRect();
      canScrollRight = lastProductRect.right - scrollerRect.right > 2;
    }

    if (!hasOverflow) {
      prevButton.classList.remove('is-visible');
      nextButton.classList.remove('is-visible');
      updateButtonPositions();
      return;
    }

    if (canScrollLeft) {
      prevButton.classList.add('is-visible');
    } else {
      prevButton.classList.remove('is-visible');
    }

    if (canScrollRight) {
      nextButton.classList.add('is-visible');
    } else {
      nextButton.classList.remove('is-visible');
    }

    updateButtonPositions();
  }

  function refreshButtonsAfterInteraction() {
    requestAnimationFrame(updateScrollButtons);
    setTimeout(updateScrollButtons, 220);
  }

  function getCardScrollAmount() {
    if (!productItems.length) {
      return Math.round(scroller.clientWidth * 0.7);
    }

    var firstCard = productItems[0];
    var firstCardStyles = window.getComputedStyle(firstCard);
    var horizontalMargins = parseFloat(firstCardStyles.marginLeft || '0') + parseFloat(firstCardStyles.marginRight || '0');
    var cardWidth = firstCard.getBoundingClientRect().width + horizontalMargins;
    return Math.max(1, Math.round(cardWidth));
  }

  function getVisibleContentStart() {
    if (!labelsColumn) {
      return 0;
    }

    var scrollerRect = scroller.getBoundingClientRect();
    var labelsRect = labelsColumn.getBoundingClientRect();
    return Math.max(0, Math.ceil(labelsRect.right - scrollerRect.left));
  }

  prevButton.addEventListener('click', function () {
    scroller.scrollBy({
      left: -getCardScrollAmount(),
      behavior: 'smooth'
    });
    refreshButtonsAfterInteraction();
  });
  nextButton.addEventListener('click', function () {
    scroller.scrollBy({
      left: getCardScrollAmount(),
      behavior: 'smooth'
    });
    refreshButtonsAfterInteraction();
  });
  scroller.addEventListener('scroll', updateScrollButtons, {
    passive: true
  });
  window.addEventListener('resize', updateScrollButtons);
  window.addEventListener('load', updateScrollButtons);
  updateScrollButtons();
})();
/******/ })()
;